var carouselCleanup = null;

document.addEventListener("turbo:load", initFeaturesCarousel);

document.addEventListener("turbo:before-cache", function () {
  if (carouselCleanup) carouselCleanup();
});

function initFeaturesCarousel() {
  if (carouselCleanup) carouselCleanup();

  if (!document.body.classList.contains("mobile-web-ai")) return;

  var trigger = document.getElementById("mwai-features-trigger");
  var sheet = document.getElementById("mwai-features-sheet");
  var backdrop = document.getElementById("mwai-features-backdrop");
  var closeBtn = document.getElementById("mwai-features-close");
  var nextBtn = document.getElementById("mwai-features-next");
  var backBtn = document.getElementById("mwai-features-back");
  var dotsContainer = document.getElementById("mwai-features-dots");

  if (!trigger || !sheet) return;

  var slides = sheet.querySelectorAll(".mwai-features-slide");
  var dots = dotsContainer ? dotsContainer.querySelectorAll(".mwai-features-dot") : [];
  var totalSlides = slides.length;
  var current = 0;

  function showSlide(index) {
    current = index;

    for (var i = 0; i < slides.length; i++) {
      slides[i].style.transform = "translateX(" + (-current * 100) + "%)";
    }

    for (var j = 0; j < dots.length; j++) {
      if (j === current) {
        dots[j].classList.add("active");
      } else {
        dots[j].classList.remove("active");
      }
    }

    if (backBtn) {
      backBtn.style.display = current > 0 ? "" : "none";
    }

    if (nextBtn) {
      var isLast = current === totalSlides - 1;
      var label = nextBtn.querySelector(".mwai-features-nav-next-label");
      var icon = nextBtn.querySelector(".fa");
      if (label) label.textContent = isLast ? "Get started" : "Next";
      if (icon) icon.style.display = isLast ? "none" : "";
    }
  }

  function open() {
    showSlide(0);
    sheet.classList.add("active");
    if (backdrop) backdrop.classList.add("active");
    document.body.style.overflow = "hidden";
  }

  function close() {
    sheet.classList.remove("active");
    if (backdrop) backdrop.classList.remove("active");
    document.body.style.overflow = "";
  }

  function onTriggerClick(e) {
    e.preventDefault();
    open();
  }

  function onNextClick() {
    if (current < totalSlides - 1) {
      showSlide(current + 1);
    } else {
      close();
    }
  }

  function onBackClick() {
    if (current > 0) {
      showSlide(current - 1);
    }
  }

  function onKeydown(e) {
    if (e.key === "Escape" && sheet.classList.contains("active")) {
      close();
    }
  }

  trigger.addEventListener("click", onTriggerClick);
  if (closeBtn) closeBtn.addEventListener("click", close);
  if (backdrop) backdrop.addEventListener("click", close);
  if (nextBtn) nextBtn.addEventListener("click", onNextClick);
  if (backBtn) backBtn.addEventListener("click", onBackClick);
  document.addEventListener("keydown", onKeydown);

  var dotHandlers = [];
  for (var k = 0; k < dots.length; k++) {
    (function (dotIndex) {
      var handler = function () { showSlide(dotIndex); };
      dots[dotIndex].addEventListener("click", handler);
      dotHandlers.push({ el: dots[dotIndex], handler: handler });
    })(k);
  }

  showSlide(0);

  carouselCleanup = function () {
    close();
    trigger.removeEventListener("click", onTriggerClick);
    if (closeBtn) closeBtn.removeEventListener("click", close);
    if (backdrop) backdrop.removeEventListener("click", close);
    if (nextBtn) nextBtn.removeEventListener("click", onNextClick);
    if (backBtn) backBtn.removeEventListener("click", onBackClick);
    document.removeEventListener("keydown", onKeydown);
    for (var d = 0; d < dotHandlers.length; d++) {
      dotHandlers[d].el.removeEventListener("click", dotHandlers[d].handler);
    }
    dotHandlers = [];
    carouselCleanup = null;
  };
}
